// axios的封装处理

import axios from "axios";
import { getToken, removeToken } from "./localStorage/token";
import { Router } from "react-router-dom";
import { message } from "antd";
import { history } from "./history";
// import { setLoginState } from "../store/modules/userStore";

// 根域名
const request = axios.create({
  baseURL: "https://waimaigui.com/api",
  //https://ff0d-202-197-226-83.ngrok-free.app
  // 'https://b6ae-202-197-226-83.ngrok-free.app/admin',
  // baseURL:'http://47.120.10.131/admin',
  timeout: 8000, // 超时时间
});

// 请求拦截器/响应拦截器
// 1.添加请求拦截器
request.interceptors.request.use(
  function (config) {
    // if (config.url.includes("/refresh/token/admin")) {
    //   console.log('排除refreshTokenAPI中')
    //   return config;
    // }
    // 在发送请求之前做些什么,插入一些自定义的配置【参数处理】
    // 操作config，注入token
    // config.headers["ngrok-skip-browser-warning"] = "69420";
    const tokenInfo = getToken();

    if (tokenInfo) {
      // config.headers.Authorization='Bearer '+token //根据后端来调整
      // await refreshToken();
      // 刷新完成后，更新请求头的 token
      config.headers["admin_access_token"] = tokenInfo.admin_access_token;
    }
    //config.headers["admin_access_token"] =
    //  "eyJhbGciOiJIUzI1NiJ9.eyJleHBNaWxsaXMiOjE3NDE5NzAxMzQ3NzMsInJvb3QiOjEsIm5hbWUiOiJhZG1pbiIsIm1hbmFnZXJJZCI6MSwiZXhwIjoxNzQxOTcwMTM0LCJ1c2VybmFtZSI6ImFkbWluIn0.fzaXf4YGN_PK7RzcMTmdVJee9iWjCQNmImijOxp5W0k";
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 2.添加响应拦截器
// 在返回客户端之前做拦截，重点处理拦截的数据
request.interceptors.response.use(
  function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    if (response.data.code === 200) {
      return response;
    } else {
      if (response.data.message === "admin_access_token无效") {
        // history.replace("/login", { from: history.location.pathname });
        // window.location.reload(); // 强制刷新页面
        removeToken();
        message.error("登录信息已过期，请重新登录", 1, () => {
          history.push("/login");
          window.location.reload();
        });
        // window.location.href = '/login';

        // Route.navigate("/login").then(() => {
        //   window.location.reload(); // 强制刷新
        // });
      }
      return Promise.reject(response.data);
    }
  },
  function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    // 超出 2xx 范围的状态码都会触发该函数
    console.dir(error);

    // 网络错误
    if (error.code === "ERR_NETWORK") {
      message.error("网络错误，请检查网络连接");
      return Promise.reject(error);
    }

    // 请求超时
    if (error.code === "ECONNABORTED") {
      message.error("请求超时，请稍后重试");
      return Promise.reject(error);
    }

    // 未授权（401）
    if (error.response && error.response.status === 401) {
      removeToken();
      Router.navigate("/login").then(() => {
        window.location.reload(); // 强制刷新
      });
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default request;
